import React from "react";
import {QuestionarioVeterinarioObject} from "../../../models/Questionario";
import FieldView from "../../../components/FieldView";
import {formDefVeterinario} from "./forms";
import EntityView from "../../../components/EntityView";
import {FormQuestionarioVeterinario} from "./FormQuestionarioVeterinario";
import {EventoObject} from "../../../models/Evento";

interface Props {
  history: any;
  questionario: QuestionarioVeterinarioObject;
  onReload: () => void;
  onDelete: () => Promise<string | void>;
  evento: EventoObject;
  principal: any;
  allowDelete: boolean;
}

export const QuestionarioVeterinario:React.FC<Props> = (
  {
    questionario, onReload, onDelete, evento, principal,
    allowDelete,
  }) => {
  return (
    <>
      <EntityView
        instance={questionario}
        ModelForm={FormQuestionarioVeterinario}
        modelFormProps={{evento, principal}}
        entityLabel="Questionário"
        gender="m"
        onReload={onReload}
        onDelete={onDelete}
        allowDelete={allowDelete}
        allowEdit={allowDelete}
      >
        <div className="text-2xl font-bold mb-4">
          Questionário
        </div>
        <FieldView value={questionario.produtos_abordados} def={formDefVeterinario.produtos_abordados}/>
        <FieldView value={questionario.observacoes} def={formDefVeterinario.observacoes}/>
      </EntityView>
    </>
  )
};
